import React from "react";

const Settings = () => {
  return (
    <React.Fragment>
      <h1>Settings</h1>
    </React.Fragment>
  );
};

export default Settings;
